import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { PropsBuilder } from '../__base/props-builder';

export class AccountsDropdownPropsBuilder extends PropsBuilder<'accountsDropdown'> {
  constructor(props: PartialPropsOf<'accountsDropdown'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
